import { useEffect, useState } from 'react'
import styled from 'styled-components'
import copy from 'copy.json'
import { useStore } from 'store'
import { WarningIcon } from 'icons'
import Modal from 'components/Modal'
import Button from 'components/Button'

export default function GlobalErrorModal() {
  const { errors, clearErrors } = useStore()
  const [isOpen, setIsOpen] = useState(errors.length > 0)

  useEffect(() => {
    if (errors.length > 0) setIsOpen(true)
  }, [errors])

  const handleClose = () => {
    setIsOpen(false)
  }

  const handleAnimationEnd = () => {
    if (!isOpen) clearErrors()
  }

  return (
    <Modal isOpen={isOpen} onAnimationEnd={handleAnimationEnd} onClose={handleClose}>
      <WarningIcon />

      {errors.map((error, index) => (
        <h1 key={index}>{error}</h1>
      ))}

      <StyledButton onClick={handleClose}>{copy.error_modal.button}</StyledButton>
    </Modal>
  )
}

const StyledButton = styled(Button)`
  width: 100%;
  max-width: 312px;
  margin-bottom: 40px;
`
